/**
 * PostPaymentModal - Premium dark + gold success state after Razorpay payment
 */
import { CheckCircle2, ArrowRight } from "lucide-react";

export function PostPaymentModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center" data-testid="post-payment-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
      <div
        className="relative z-10 max-w-[400px] w-full mx-4 rounded-2xl overflow-hidden"
        style={{
          background: "linear-gradient(165deg, #1c1917 0%, #292524 40%, #1c1917 100%)",
          boxShadow: "0 0 80px rgba(202,138,4,0.12), 0 25px 60px rgba(0,0,0,0.5)",
        }}
        data-testid="post-payment-content"
      >
        {/* Emerald + gold accent bar */}
        <div className="h-1" style={{ background: "linear-gradient(90deg, #065f46, #059669, #d97706, #059669, #065f46)" }} />

        <div className="px-7 pt-8 pb-7 text-center">
          {/* Success icon */}
          <div
            className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5"
            style={{ background: "rgba(16,185,129,0.12)" }}
          >
            <CheckCircle2 className="h-8 w-8" style={{ color: "#34d399" }} />
          </div>

          {/* Header */}
          <p className="text-[10px] font-medium tracking-[0.25em] uppercase mb-2" style={{ color: "#a8956e" }}>
            Payment Successful
          </p>
          <h2
            className="text-xl font-bold mb-2 tracking-tight"
            style={{ color: "#f5f0e8", fontFamily: "Inter, system-ui, sans-serif" }}
            data-testid="post-payment-title"
          >
            Welcome to Studio Pass 2.0
          </h2>
          <div className="mx-auto my-3 w-16 h-px" style={{ background: "linear-gradient(90deg, transparent, #b8973a, transparent)" }} />

          <p className="text-[13px] leading-relaxed mb-6" style={{ color: "#b0a594" }}>
            You now have full access to the library.
            <br />
            Start downloading and upgrading your menu instantly.
          </p>

          {/* CTA Button */}
          <button
            data-testid="post-payment-cta"
            onClick={onClose}
            className="w-full h-13 flex items-center justify-center gap-2 rounded-xl text-sm font-bold tracking-wide transition-all duration-200"
            style={{
              background: "linear-gradient(135deg, #92400e 0%, #d97706 30%, #f59e0b 50%, #d97706 70%, #92400e 100%)",
              color: "#1c1917",
              boxShadow: "0 0 24px rgba(245,158,11,0.25), 0 4px 12px rgba(0,0,0,0.3)",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 0 36px rgba(245,158,11,0.4), 0 6px 16px rgba(0,0,0,0.3)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 0 24px rgba(245,158,11,0.25), 0 4px 12px rgba(0,0,0,0.3)"; }}
          >
            Start Exploring Full Library
            <ArrowRight className="h-4 w-4" />
          </button>

          {/* Trust text */}
          <p className="text-[11px] mt-4" style={{ color: "#8a7e6e" }}>
            Pre-approved visuals for <span style={{ color: "#E23744" }}>Zomato</span> & <span style={{ color: "#FC8019" }}>Swiggy</span> &bull; New photos added regularly
          </p>
          <p className="text-[10.5px] font-medium mt-1" style={{ color: "#a8956e" }}>
            Your menu upgrade starts now.
          </p>
        </div>
      </div>
    </div>
  );
}
